import uniqBy from 'lodash/uniqBy'
import find from 'lodash/find'

import BraintreePaymentComponent from './BraintreePaymentComponent'

// https://lodash.com/docs/4.17.10#uniqBy
const isAllUniqueValues = (list, iteratee = x => x) => {
  const len = list.length;
  const uniqLength = uniqBy(list, iteratee).length;
  return len === uniqLength;
}


const addressesAreInvalid = (addresses) => {
  if (!isAllUniqueValues(addresses, address => address.Id)) {
    console.error('not all Ids unique for ShippingAddresses and BillingAddresses');
    return true;
  }
}

const shippingOptionsAreInvalid = (shippingOptions) => {
  if (!isAllUniqueValues(shippingOptions, so => so.Id)) {
    console.error('not all Ids unique for ShippingOptions');
    return true;
  }
}

const paymentOptionsAreInvalid = (paymentOptions) => {
  if (!isAllUniqueValues(paymentOptions, po => po.Id)) {
    console.error('not all Ids unique for PaymentOptions');
    return true;
  }
}

const cartItemsAreInvalid =(cartItems) => {
  if (!isAllUniqueValues(cartItems, ci => ci.Id)) {
    console.error('not all Ids unique for CartItems');
    return true;
  }
}

// Perhaps https://validatejs.org/ would be useful here
const initialDataIsInvalid = (initialData) => {
  // BBS DDD 2018-03-07 Don't validate address id uniqueness. Addresses can be of multiple types
  //let addresses = initialData.BillingAddresses.concat(initialData.ShippingAddresses);
  //if (addressesAreInvalid(addresses)) {
  //  return true;
  //}
  if (shippingOptionsAreInvalid(initialData.ShippingOptions)) {
    return true;
  }
  if (paymentOptionsAreInvalid(initialData.PaymentOptions)) {
    return true;
  }
  if (cartItemsAreInvalid(initialData.CartItems)) {
    return true;
  }
}

const mapTopLevelPropsToInitialStoreState = props => {
  // validate
  if (initialDataIsInvalid(props.initialData)) {
    return {};
  };

  // Do some calculations for init
  let selectedShippingOption = props.initialData.ShippingOptions.filter(so => so.IsSelected)[0];
  if (!selectedShippingOption && props.initialData.ShippingOptions[0]) {
    selectedShippingOption = props.initialData.ShippingOptions[0].Id;
  }

  // Add controls to payment if they have one
  const paymentOptions = props.initialData.PaymentOptions.map(po => {
    if (po.Id === props.BraintreeClientSettings.BraintreePaymentOptionId) {
      po.paymentOptionComponent = BraintreePaymentComponent;
    }
    return po;
  });

  let selectedPaymentOption = find(paymentOptions, po => po.IsSelected);
  if (!selectedPaymentOption) {
    selectedPaymentOption = paymentOptions[0];
  }

  const allowBillingEqualsShipping = props.initialData.AllowBillingEqualsShipping;
  const selectedShippingAddressId = props.initialData.ShippingAddresses[0] && props.initialData.ShippingAddresses[0].Id;
  const selectedBillingAddressId = (allowBillingEqualsShipping && selectedShippingAddressId)
    ? (selectedShippingAddressId)
    : (props.initialData.BillingAddresses[0] && props.initialData.BillingAddresses[0].Id);
  return {
    // BBS DDD 2017-11-19 The state of the ui. Make all ui updates here.
    ui: {
      PhoneNumber: props.initialData.PhoneNumber,
      PhoneText: props.initialData.PhoneText,
      useShippingForBilling: allowBillingEqualsShipping,
      messages: [],
      completeCheckoutButtonText: "Place Order",
      isPlaceOrderPending: false,
      selectedPaymentLabel: ""
    },
    // BBS DDD 2017-11-19 The state of the checkout. Make all business
    // updates here
    entities: {
      Addresses: props.initialData.BillingAddresses.concat(props.initialData.ShippingAddresses),
      BillingAddresses: props.initialData.BillingAddresses.map(addr => addr.Id),
      SelectedBillingAddressId: selectedBillingAddressId,
      ShippingAddresses: props.initialData.ShippingAddresses.map(addr => addr.Id),
      SelectedShippingAddressId: selectedShippingAddressId,
      CartItems: props.initialData.CartItems,
      OrderNumber: 0,
      PaymentOptions: paymentOptions,
      SelectedPaymentOptionId: selectedPaymentOption && selectedPaymentOption.Id || '',
      ShippingOptions: props.initialData.ShippingOptions,
      SelectedShippingOptionId: selectedShippingOption && selectedShippingOption.Id || '',
      SubTotal: props.initialData.SubTotal,
      Summary: {
        Total: props.initialData.CheckoutSummary.Total,
        SubTotal: props.initialData.CheckoutSummary.SubTotal,
        ShippingTotal: props.initialData.CheckoutSummary.ShippingTotal,
        Currency: props.initialData.CheckoutSummary.Currency,
        TotalRemaining: props.initialData.CheckoutSummary.Total
      },
      PaymentRecord: {}
    },
    // BBS DDD 2017-11-19 Data definitions and other things
    constants: {
      // Locations of server resources
      navigation: {
        MyAccountLink: '',
        checkoutUrl: props.checkoutUrl,
        ReceiptUrl: props.initialData.ReceiptUrl,
        addAddressEndpoint: props.addAddressEndpoint,
        deleteAddressEndpoint: props.deleteAddressEndpoint,
        cartSummaryEndpoint: props.cartSummaryEndpoint,
        braintreeClientTokenEndpoint: props.braintreeClientTokenEndpoint,
        placeOrderEndpoint: props.placeOrderEndpoint,
        orderConfirmationUrl: props.orderConfirmationUrl,
        updateItemQuantityEndpoint: props.updateQuantityEndpoint,
        deleteItemEndpoint: props.deleteItemEndpoint
      },
      ShippingAddressType: props.ShippingAddressType,
      BillingAddressType: props.BillingAddressType,
      countriesStatesMap: props.countriesStatesMap,
      countries: props.countries,
      braintreeSettings: {
        usePaypal: props.BraintreeClientSettings.BraintreePaypalEnabled,
        usePaypalCredit: props.BraintreeClientSettings.BraintreePaypalCreditEnabled,
        braintreePaypalFlow: props.BraintreeClientSettings.BraintreePaypalFlow,
        braintreePaymentId: props.BraintreeClientSettings.BraintreePaymentOptionId,
      },
      allowBillingEqualsShipping: props.initialData.allowBillingEqualsShipping
    }
  }
}


export default mapTopLevelPropsToInitialStoreState